import React from "react"
import { Typography } from "@material-ui/core"
import { completeUrlForHrefLink } from "../../../commons/iFrameUtils"

/*
 * This component renders a Cell of a Table inside a Widget component
 * Passed 'style' (inside 'cell' object) normally comes directly from JUMP, if the table cell has a style.
 * Otherwise, it is expected to have a 'style' property
 * */
const Cell = (value, tableMeta, cell) => {
  const { text } = value
  const style = cell?.style || {}

  if (text.match(/<.+>.+<.+>/)) {
    /* necessary because reports can have html embedded */
    /* eslint-disable-next-line react/no-danger */
    const htmlText = completeUrlForHrefLink(text)
    return (
      <div dangerouslySetInnerHTML={{ __html: htmlText }} style={{ flex: 1 }} />
    )
  }

  // TODO: Has a second prop (cell) where all attributes can be found
  // TODO: Implement other attributes
  return (
    <Typography component="span" variant="body2" style={style}>
      {text}
    </Typography>
  )
}

export default Cell
